/**
 * Sub-navigation inside the /docs section. Mirrors AdminTabs / AppTabs.
 */

import { NavLink } from 'react-router-dom';
import type { IconShield } from './Icons.js';
import {
  IconBolt,
  IconBot,
  IconGlobe,
  IconInfo,
  IconPlay,
  IconPlug,
  IconRocket,
  IconSparkle,
} from './Icons.js';

interface Tab {
  to: string;
  label: string;
  icon: typeof IconShield;
  end?: boolean;
}

const tabs: Tab[] = [
  { to: '/docs', label: 'Overview', icon: IconSparkle, end: true },
  { to: '/docs/using-apps', label: 'Using apps', icon: IconGlobe },
  { to: '/docs/getting-started', label: 'Getting started', icon: IconRocket },
  { to: '/docs/first-app', label: 'First app', icon: IconBolt },
  { to: '/docs/prompting', label: 'Prompting', icon: IconBot },
  { to: '/docs/examples', label: 'Examples', icon: IconPlay },
  { to: '/docs/connections', label: 'Private connections', icon: IconPlug },
  { to: '/docs/faq', label: 'FAQ', icon: IconInfo },
];

export function DocsTabs() {
  return (
    <nav
      aria-label="Docs sections"
      className="-mx-4 sm:-mx-6 px-4 sm:px-6 mb-8 border-b border-line"
    >
      <div className="flex items-center gap-1 overflow-x-auto pb-px">
        {tabs.map(({ to, label, icon: Icon, end }) => (
          <NavLink
            key={to}
            to={to}
            {...(end ? { end: true } : {})}
            className={({ isActive }) =>
              'group relative flex items-center gap-1.5 px-3 py-2.5 text-sm font-medium whitespace-nowrap transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand/50 rounded-t-md ' +
              (isActive ? 'text-ink' : 'text-muted hover:text-ink')
            }
          >
            {({ isActive }) => (
              <>
                <Icon
                  size={14}
                  className={isActive ? 'text-brand' : 'text-faint group-hover:text-muted'}
                />
                <span>{label}</span>
                {isActive && (
                  <span
                    aria-hidden
                    className="absolute left-2 right-2 -bottom-px h-0.5 bg-brand rounded-full"
                  />
                )}
              </>
            )}
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
